module.exports = __webpack_public_path__ + "static/media/oeuf-brouilles.1f029276.svg";